import { API } from "./api";

const VISITOR_KEY = "omk_visitor_id";
const FAV_KEY = "omk_favorites";

export function getVisitorId() {
  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
}

export function getFavorites() {
  try { return JSON.parse(localStorage.getItem(FAV_KEY) || "[]"); } catch (_) { return []; }
}

export function isFavorite(slug) {
  return getFavorites().includes(slug);
}

function setFavorites(list) {
  localStorage.setItem(FAV_KEY, JSON.stringify(list));
  window.dispatchEvent(new Event("omk-favorites-changed"));
}

export async function toggleFavorite(slug) {
  const favs = getFavorites();
  const has = favs.includes(slug);
  const next = has ? favs.filter((s) => s !== slug) : [...favs, slug];
  setFavorites(next);
  try {
    await fetch(`${API}/listings/${slug}/favorite`, {
      method: "POST", credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ visitor_id: getVisitorId(), action: has ? "remove" : "add" }),
    });
  } catch (_) { /* analytics best-effort */ }
  return !has;
}

export function trackView(slug) {
  try {
    fetch(`${API}/listings/${slug}/view`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ visitor_id: getVisitorId() }),
      keepalive: true,
    });
  } catch (_) { /* noop */ }
}

export function logSearch(filters) {
  const clean = Object.fromEntries(Object.entries(filters || {}).filter(([k, v]) => v && k !== "sort"));
  if (Object.keys(clean).length === 0) return;
  try {
    fetch(`${API}/search-log`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify(clean), keepalive: true,
    });
  } catch (_) { /* noop */ }
}
